import React from 'react';
import { Container, Row } from 'react-bootstrap';
import './Portfolio.css';
import Project from '../Project/Project';
import { projectsData } from '../../../../projectsData/projectsData';

const Portfolio = () => {
    return (
        <div id="portfolio" className="pt-5">
            <section  className="portfolio-container py-5">
                <Container>
                    <div className="portfolio-heading">
                        <h2 className="text-white text-center fw-bold fs-1">My Recent Work</h2>
                        <p className="text-secondary text-center">Visit My Portfolio and Keep Feedback</p>
                        <div className="line"></div>
                    </div>
                    <div className="projects-container py-4">
                        <Row xs={1} sm={1} md={3} className="g-4">
                            {
                                projectsData.map(project => <Project
                                    key={project.id}
                                    project={project}
                                />)
                            }
                        </Row>
                    </div>
                </Container>
            </section>
           
        </div>
    );

};

export default Portfolio;